import styled from 'styled-components';

import { SortIcon } from 'src/app/components/icons/sort-icon';

export const RowReorderingIcon = styled(SortIcon).attrs(() => ({
  dataTestId: 'row-reordering-icon',
  fill: 'var(--color-gray-60)',
}))``;
